import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "BaseForm",
  novalidate: "novalidate"
}

import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseForm',
  props: {
    sendLoading: { type: Boolean },
    sendSuccess: { type: Boolean },
    keepLoadingSendOnSuccess: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const isSendLoading = computed(() => (
  props.sendLoading
  || (props.keepLoadingSendOnSuccess && props.sendSuccess)
));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _renderSlot(_ctx.$slots, "default", { isFormSendLoading: isSendLoading.value })
  ]))
}
}

})